import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { certificationCreateSchema } from '../core/validations/certification';

/**
 * Formulário da CRIAÇÃO de questionário de certificação.
 *
 * EG-42/AD-2 e AD-8: o hook encolheu.
 *
 * Saiu o estado hasPillars e o wizard de pilares (pillarCount,
 * handleNumPilaresChange, handleHasPillarsChange, o useFieldArray de `form`).
 * Todos serviam ao rádio "Possui pilares?" e ao "Número de pilares", que a AD-8
 * removeu: a forma do certificado passou a ser derivada do que os templates
 * trazem, e o rádio decidia — sem dizer — o MODELO DE NOTA do certificado.
 *
 * Saiu também a escolha entre dois schemas. As perguntas deixaram de ser campo
 * do formulário e viraram seleção de templates em estado do componente, então
 * um schema que as exigisse manteria isValid FALSO para sempre e o botão
 * Finalizar desabilitado — foi o defeito achado no teste exploratório.
 * Quem valida "tem pelo menos uma pergunta" é a tela, contra a seleção.
 */
export const useCertificationForm = () => {
  const formMethods = useForm({
    resolver: yupResolver(certificationCreateSchema),
  });

  return { formMethods };
};
